import * as modules from "./modules/";
import config from "../../../../config";

const { vendor } = config;

const FlexSeparatedRow = modules[vendor]
  ? modules[vendor]
  : modules["default"];

export default FlexSeparatedRow;
